import WaIcon from "@/components/whatsapp/WaIcon";
import CustomerAvatar from "@/components/customers/CustomerAvatar";

export default function WaConvAvatar({ conv, size = 36 }) {
    const photo = conv.customer?.photo_url || conv.avatar_url;
    if (photo || conv.customer) {
        return <CustomerAvatar customer={{ name: conv.name || conv.phone, photo_url: photo }} size={size} />;
    }
    return (
        <span style={{ width: size, height: size }} className="rounded-full bg-[#25D366]/15 text-[#25D366] grid place-items-center shrink-0">
            <WaIcon className="w-4 h-4" />
        </span>
    );
}
